import { IUserActionTypes, ImpersonateUserParams } from 'types';

export const fetchIUserStart = (params: ImpersonateUserParams) => ({
  type: IUserActionTypes.FETCH_IUSER_START,
  payload: params
});

export const fetchIUserSuccess = (users: any) => ({
  type: IUserActionTypes.FETCH_IUSER_SUCCESS,
  payload: users
});

export const fetchIUserFailure = (error: any) => ({
  type: IUserActionTypes.FETCH_IUSER_FAILURE,
  payload: error
});
